// extracted by mini-css-extract-plugin
module.exports = {"searchForm":"words-search-module--searchForm--TSS3l","searchField":"words-search-module--searchField--2_2nA","searchBtn":"words-search-module--searchBtn--UKU1k"};